import { Entity, type EnemyConstruction } from "../Entity";

/** Standard authored enemy that orbits and fires without a melee state. */
export class RangedEntity extends Entity {
  constructor(init: EnemyConstruction) {
    super(init);
  }
}
